import React, { Component } from "react";
import { Row, Col, Form, DatePicker, Input, Checkbox } from 'antd';
import { UserPhoto } from "../../../common/userPhoto/userPhoto";
import moment from 'moment-timezone';

const FormItem = Form.Item;
const REVIVAL_FINISH_PHASE = 3;

export class ChurchRevivalFields extends Component {
  get preparationDaysCount() {
    const {getFieldValue} = this.props.form;
    return this.periodDaysCount(getFieldValue('revival.preparation_start_date'), getFieldValue('revival.start_date'));
  }

  get revivalDaysCount() {
    const {getFieldValue} = this.props.form;
    return this.periodDaysCount(getFieldValue('revival.start_date'), getFieldValue('revival.end_date'));
  }

  componentDidMount() {
    this.props.form.setFieldsValue({ add_revival: this.props.church && this.props.church.revival.id > 0 });
  }

  disabledDate = (current) => {
    return current && current < moment().endOf('day');
  };

  revivalPreparationDisabledDate = (current) => {
    const {getFieldValue} = this.props.form;
    if (current && getFieldValue('revival.start_date')) {
      return !current.isBetween(moment().endOf('day'), getFieldValue('revival.start_date'), null, '[)');
    } else if (current && getFieldValue('revival.end_date')) {
      return !current.isBetween(moment().endOf('day'), getFieldValue('revival.end_date'), null, '[)');
    } else {
      return this.disabledDate(current);
    }
  };

  revivalStartDisabledDate = (current) => {
    const {getFieldValue} = this.props.form;
    if (current && getFieldValue('revival.preparation_start_date') && getFieldValue('revival.end_date')) {
      return !current.isBetween(getFieldValue('revival.preparation_start_date'), getFieldValue('revival.end_date'), null, '[]');
    } else if (current && getFieldValue('revival.end_date')) {
      return !current.isBetween(moment().endOf('day'), getFieldValue('revival.end_date').endOf('day'), null, '[]');
    } else if (current && getFieldValue('revival.preparation_start_date')) {
      return !current.isAfter(getFieldValue('revival.preparation_start_date'), 'day');
    } else {
      return this.disabledDate(current);
    }
  };

  revivalEndDisabledDate = (current) => {
    const {getFieldValue} = this.props.form;
    if (current && getFieldValue('revival.start_date')) {
      return !current.isSameOrAfter(getFieldValue('revival.start_date'), 'day');
    } else if (current && getFieldValue('revival.preparation_start_date')) {
      return !current.isAfter(getFieldValue('revival.preparation_start_date'), 'day');
    } else {
      return this.disabledDate(current);
    }
  };

  periodDaysCount(startDate, endDate) {
    if (startDate && endDate) {
      return endDate.diff(startDate, 'days');
    }
  }

  churchPhaseCheck(church, phaseNumber) {
    if (church && church.revival) {
      return church.revival.phase === REVIVAL_FINISH_PHASE ? false : church.revival.phase > phaseNumber;
    } else {
      return false;
    }
  }

  onPhotoLoad = (photoDataUri) => {
    this.props.form.setFieldsValue({ revival: { image_data_uri: photoDataUri } });
  };

  resolveValue = (fieldName) => {
    const { church } = this.props;

    if (!church) return null;

    if (church.revival && church.revival.phase === REVIVAL_FINISH_PHASE) return null;

    return church.revival ? church.revival[fieldName] : '';
  }

  resolveDateValue = (fieldName) => {
    const { church } = this.props;

    if (!church) return null;

    if (church.revival && church.revival.phase === REVIVAL_FINISH_PHASE) return null;

    return church.revival ? moment.unix(church.revival[fieldName]).tz(church.timezone) : '';
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { church } = this.props;

    return (
      <Row className="church-form__revival-schedule">
        <Col span={8}>
          <FormItem label="">
            {getFieldDecorator('add_revival', {
              initialValue: church && church.revival
            })(
              <Checkbox checked={!!getFieldValue('add_revival')}>Add event</Checkbox>
            )}
          </FormItem>
        </Col>

        {getFieldValue('add_revival') &&
          <div>
            <Col xs={{ span: 24 }} md={{ span: 16 }} xl={{ span: 20 }}>
              <Row>
                <FormItem label="Title">
                  {getFieldDecorator('revival.title', {
                    initialValue: this.resolveValue('title'),
                    rules: [
                      { required: getFieldValue('add_revival'), message: 'Please input title' }
                    ],
                  })(
                    <Input placeholder="Title" />
                  )}
                </FormItem>
              </Row>

              <Row>
                <Col span={8}>
                  <FormItem label="Event Preparation start">
                    {getFieldDecorator('revival.preparation_start_date', {
                      rules: [
                        { required: getFieldValue('add_revival'), message: 'Please specify Event preparation start date' }
                      ],
                      initialValue: this.resolveDateValue('preparationStartDate')
                    })(
                      <DatePicker size="small" disabledDate={this.revivalPreparationDisabledDate} disabled={this.churchPhaseCheck(church, 0)}/>
                    )}
                  </FormItem>
                </Col>
                <Col span={8}>
                  <FormItem label="Event start">
                    {getFieldDecorator('revival.start_date', {
                      rules: [
                        { required: getFieldValue('add_revival'), message: 'Please specify Event start date' }
                      ],
                      initialValue: this.resolveDateValue('startDate')
                    })(
                      <DatePicker size="small" disabledDate={this.revivalStartDisabledDate} disabled={this.churchPhaseCheck(church, 0)}/>
                    )}
                  </FormItem>
                </Col>
                <Col span={8}>
                  <FormItem label="Event finish">
                    {getFieldDecorator('revival.end_date', {
                      rules: [
                        { required: getFieldValue('add_revival'), message: 'Please specify Event finish date' }
                      ],
                      initialValue: this.resolveDateValue('endDate')
                    })(
                      <DatePicker size="small" disabledDate={this.revivalEndDisabledDate} disabled={this.churchPhaseCheck(church, 3)}/>
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Col>

            <Col xs={{ span: 24 }} md={{ span: 7, offset: 1 }} xl={{ span: 3, offset: 1 }}>
              <FormItem>
                {getFieldDecorator('revival.image_data_uri', {
                  initialValue: '',
                  rules: [
                    { required: getFieldValue('add_revival') && (!church || church.revival.phase === REVIVAL_FINISH_PHASE), message: 'Please input event image' }
                  ],
                })(
                  <UserPhoto photoURL={church && church.revival.image && church.revival.image.default}
                             onPhotoLoad={this.onPhotoLoad}
                             hideRemoveButton/>
                )}
              </FormItem>
            </Col>

            <Col span={24}>
              <p><b>EVENT PREP DAYS: { this.preparationDaysCount || 'XX'}</b> Recomended length of Event Prep phase - no more than 49 days</p>
              <p><b>EVENT DAYS: { this.revivalDaysCount || 'XX'}</b> Recomended length of Event phase - no more than 4 days</p>
            </Col>
          </div>
        }
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churches/form/churchRevivalFields.js